// ** React Imports
import { useCallback } from 'react';

// ** CoreUI Imports
import { CButton, CModal, CModalBody, CForm } from '@coreui/react';
import CIcon from '@coreui/icons-react';

// ** Validations
import { Formik } from 'formik';
import { SAVED_VIEW_TYPE } from '../../../../../../constants/reportView';
import PropTypes from 'prop-types';

const Confirm = (props) => {
     const { show, data, onAccept, onCancel } = props;

     const initialValues = {
          name: '',
          description: '',
          isDefault: false,
     };

     const isSaveViewTypeDelete = data.type === SAVED_VIEW_TYPE.DELETE;

     const RenderHeader = useCallback(() => {
          if (!isSaveViewTypeDelete) {
               return (
                    <h1>{data.confirmTitle}</h1>
               );
          }
          return (
               <>
                    <div className="remove-popup-icon">
                         <CIcon icon="icon-delete" className="text-danger" height={38} alt="CoreUI Icons Delete" />
                    </div>
                    <h2>{data.confirmTitle}</h2>
               </>
          );
     }, [data, isSaveViewTypeDelete]);

     const RenderFooter = useCallback(({ handleSubmit, isSubmitting }) => {
          if (!isSaveViewTypeDelete) {
               return (
                    <CForm onSubmit={handleSubmit}>
                         <div className="form-actions">
                              <CButton type="submit" color="primary" className="mr-3" disabled={isSubmitting}>
                                   {isSubmitting ? (<span className="dots-waiting">Waiting</span>) : 'Confirm'}
                              </CButton>

                              <CButton className="btn btn-light" onClick={onCancel}>
                                   Cancel
                              </CButton>
                         </div>
                    </CForm>
               );
          }

          return (
               <CForm onSubmit={handleSubmit}>
                    <div className="btn-accept position-relative mb-3">
                         <CButton type="submit" color="danger" className="mr-3 text-uppercase d-inline-block" disabled={isSubmitting}>
                              {isSubmitting ? (<span className="dots-waiting">Waiting</span>) : 'PROCEED TO DELETE'}
                         </CButton>
                    </div>
                    <div className="mb-3">
                         <CButton className="d-inline-block btn-cancel" onClick={onCancel}>
                              Cancel
                         </CButton>
                    </div>
               </CForm>
          )
     }, [isSaveViewTypeDelete, onCancel]);

     return (
          <div className={`${isSaveViewTypeDelete ? 'remove-popup' : 'confirm-save-popup popup-publish-version'}`}>
               <CModal visible={show} onClose={onCancel} color="primary" alignment="center" portal={false}> 
                    <CModalBody className='confirm-save modal-padding-37'>
                         <CIcon icon="cil-x" onClick={onCancel} className="icon-close-popup" />

                         <div className="popup-publish-version-description">
                              {RenderHeader()}
                              <p>{data.confirmDescription}</p>
                         </div>

                         <Formik initialValues={initialValues} onSubmit={onAccept} onClose={onCancel} validateOnChange={false} validateOnBlur={false}>
                              {({ handleSubmit, isSubmitting }) => {
                                   return <RenderFooter handleSubmit={handleSubmit} isSubmitting={isSubmitting} />;
                              }}
                         </Formik>
                    </CModalBody>
               </CModal>
          </div>
     );
};


Confirm.propTypes = {
     onCancel: PropTypes.func,
     onAccept: PropTypes.func,
     show: PropTypes.any,
     data: PropTypes.array,
};

export default Confirm;
